import axios from 'axios';
import { buildQueryString, QueryParam } from '../queryUtils';
import { baseUrl } from '../apiUrl';
import { Alert, Alerts, AlertsCounts } from './types';



// Get all Alerts
export const getAlerts= async (query:QueryParam): Promise<Alerts> => {
    try {
        const response = await axios.get<Alerts>(`${baseUrl}/clo-hms/homesite/alerts?${buildQueryString(query)}`);
        return response.data;
    } catch (error) {
        throw new Error(`Failed to fetch Alerts: ${error}`);
    }
};

// Aggregate Alerts By Homesite ID and Milestone Name 
export const getAlertsCounts = async (query:QueryParam): Promise<AlertsCounts<Alert>> => {
    try {
        const response = await axios.get<AlertsCounts<Alert>>(`${baseUrl}/clo-hms/homesite/alerts?${buildQueryString(query)}`);
        return response.data;
    } catch (error) {
        throw new Error(`Failed to fetch Alerts counts: ${error}`);
    }
}

// Update a specific Alert by ID and Homesite ID
export const updateAlert = async (alert: Partial<Alert>): Promise<Alert> => {
    try {
        const response = await axios.patch<Alert>(`${baseUrl}/clo-hms/homesite/alerts`, alert);
        return response.data;
    } catch (error) {
        throw new Error(`Failed to update Alerts with ID ${alert}: ${error}`);
    }
};